// Botão padrão do sistema. Extraído de GerenciarMatriculas.js, que já tinha essa
// mesma implementação reinventada localmente — use este em vez de criar outro.
import React from 'react';

const VARIANTS = {
  primary: 'bg-blue-600 hover:bg-blue-700 text-white',
  secondary:
    'bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300',
  danger: 'bg-red-600 hover:bg-red-700 text-white',
  success: 'bg-green-600 hover:bg-green-700 text-white',
};

export default function Button({
  children,
  type = 'button',
  variant = 'primary',
  size = 'md',
  onClick,
  disabled,
  icon: Icon,
  className = '',
}) {
  const sizeClass = size === 'sm' ? 'gap-1.5 px-3 h-8 text-xs' : 'gap-2 px-4 h-10 text-sm';
  const base = `inline-flex items-center justify-center rounded-xl font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed ${sizeClass}`;
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${base} ${VARIANTS[variant] || VARIANTS.primary} ${className}`}
    >
      {Icon && <Icon className={size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4'} />}
      {children}
    </button>
  );
}
